import axios from 'axios'

const Font = {
    getFontList() {
        return axios.get("https://www.googleapis.com/webfonts/v1/webfonts?sort=popularity&key=AIzaSyCCiu-WohCVoHkSFlutprM1jYzaLXhYQZo")
            .then(response => response.data)
    }
}

export default Font;
